import React from 'react'
import moment from 'moment'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcInput,
  DcText,
  PixelAlert,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { createReceivedPayment } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../decl.d'
interface IData {
  courier_id: string
  receiving_date: Date | string
  amount: string | number
  invoice_reference: string
  payment_gateway_id: string
  bank_txn_ref: string
  notes: string
  bank_id: string
  weekly_payment_header_id: number
  [key: string]: any
}
const CreateReceivedPayment = (props) => {
  const { couriers, handleClose, bankAccounts, paymentData, paymentCourier } =
    props
  const { showPageLoader, hidePageLoader, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState<IData>({
    courier_id: '',
    receiving_date: moment().format('YYYY-MM-DD'),
    amount: '',
    invoice_reference: '',
    payment_gateway_id: '',
    bank_txn_ref: '',
    notes: '',
    bank_id: '',
    weekly_payment_header_id: 1,
  })
  React.useEffect(() => {
    if (paymentCourier == 'Daraz') {
      const darazCourier = couriers?.find(
        (item) => item.courier_company == 'Daraz',
      )
      setData({
        ...data,
        courier_id: darazCourier?.courier_id,
        invoice_reference: paymentData?.statement_number,
        receiving_date:
          paymentData?.updated_at == ''
            ? new Date()
            : moment(paymentData?.updated_at).format('YYYY-MM-DD') ||
              new Date(),
        amount: paymentData?.payout,
        payment_gateway_id: darazCourier?.payment_gateway_id,
      })
    }
  }, [paymentData, paymentCourier])
  const handleSubmit = (e) => {
    e.preventDefault()

    showPageLoader()
    createReceivedPayment({
      ...data,
      receiving_date: moment(data.receiving_date).format('YYYY-MM-DD'),
    }).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        handleClose(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError(res.response.error)
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  return (
    <>
      {bankAccounts && bankAccounts.length > 0 ? (
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Select Courier
              </DcText>
              <DcDropDown
                error={
                  error.field === 'courier_id' && error.error !== ''
                    ? error.error
                    : null
                }
                disabled={paymentCourier == 'Daraz'}
                required
                placeholder="Select Courier"
                options={[
                  {
                    courier_name: 'Select Courier',
                    courier_id: '',
                  },
                  ...couriers,
                ].map((p) => {
                  return {
                    label: p.courier_name,
                    value: p.courier_id,
                  }
                })}
                value={data.courier_id}
                onChange={(e) => {
                  const courier = couriers.find(
                    (c) => c.courier_id === e.target.value,
                  )
                  setData({
                    ...data,
                    courier_id: e.target.value,
                    payment_gateway_id: courier
                      ? courier.payment_gateway_id
                      : '',
                  })
                }}
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Payment Receiving Date
              </DcText>
              <DcInput
                as="datePicker"
                error={
                  error.field === 'receiving_date' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'Payment Receiving Date'}
                placeholder={'Payment Receiving Date'}
                value={moment(data.receiving_date).format(
                  'YYYY-MM-DD 19:14:SS.SSSSSS',
                )}
                onChange={(e) =>
                  setData({
                    ...data,
                    receiving_date: moment(e).format('YYYY-MM-DD'),
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Select Bank
              </DcText>
              <DcDropDown
                error={
                  error.field === 'bank_id' && error.error !== ''
                    ? error.error
                    : null
                }
                placeholder="Select Bank"
                required
                options={[
                  {
                    bank_name: 'Select Bank',
                    bank_id: '',
                  },
                  ...bankAccounts,
                ].map((p) => {
                  return {
                    label: p.bank_name,
                    value: p.bank_id,
                  }
                })}
                value={data.bank_id}
                onChange={(e) => {
                  const account = bankAccounts.find(
                    (a) => a.bank_id === e.target.value,
                  )
                  setData({
                    ...data,
                    bank_id: account.bank_id,
                  })
                }}
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Amount
              </DcText>
              <DcInput
                error={
                  error.field === 'amount' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'Amount'}
                placeholder={'Amount'}
                value={data.amount}
                onChange={(e) =>
                  setData({ ...data, amount: Number(e.target.value) })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                invoice reference
              </DcText>
              <DcInput
                error={
                  error.field === 'invoice_reference' && error.error !== ''
                    ? error.error
                    : null
                }
                disabled={paymentCourier == 'Daraz'}
                required
                type={'text'}
                name={'invoice reference'}
                placeholder={'invoice reference'}
                value={data.invoice_reference}
                onChange={(e) =>
                  setData({ ...data, invoice_reference: e.target.value })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Transaction Reference
              </DcText>
              <DcInput
                error={
                  error.field === 'bank_txn_ref' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'Transaction Reference'}
                placeholder={'Transaction Reference'}
                value={data.bank_txn_ref}
                onChange={(e) =>
                  setData({ ...data, bank_txn_ref: e.target.value })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Notes
              </DcText>
              <DcInput
                error={
                  error.field === 'notes' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                as={'textarea'}
                type={'text'}
                name={'Notes'}
                placeholder={'Notes'}
                value={data.notes}
                onChange={(e) => setData({ ...data, notes: e.target.value })}
              />
            </DcDiv>
          </FormGroup>
          <FormGroup flexEnd>
            <DcButton variant="primary" type="submit">
              Save
            </DcButton>
          </FormGroup>
        </Form>
      ) : (
        <PixelAlert variant="danger">
          Please add bank account first to verify received payments
        </PixelAlert>
      )}
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default CreateReceivedPayment
